var exports = {
  "k": "x93eb46d8--69c29c--container",
};

module.exports = exports;
